import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';

import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class DeleteAuditStageRecordCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               private dialogService: DialogService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService, ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const message = 'All of the documents attached to this record wont be deleted. You need to clean them separately if you don\'t need them.';
    const question = 'Are you sure you want to delete this record?';

    this.dialogService.showConfirmDialog('Delete Record', 'Delete', 'Cancel', message, question).subscribe(res => {
      if (res.action === 'OK') {
        this.executeCommandToApi(command, handler);
      }
    });

    return true;
  }
}
